/**
 * sha256 файла для дедупликации загрузок: тот же файл уже в медиатеке —
 * сервер отвечает «уже есть», и файл не грузится второй раз.
 *
 * Почему с пределом. WebCrypto (`crypto.subtle.digest`) не умеет считать хэш
 * по кускам — ему нужен весь файл в памяти одним буфером. Для картинок и
 * коротких роликов это дёшево (200 МБ — доли секунды и 200 МБ памяти на
 * время подсчёта), а держать в памяти вкладки видео в 1 ГБ ради дедупликации
 * — нет. Потоковый sha256 на JS/WASM — лишняя зависимость ради редкого случая
 * (повторная загрузка того же большого видео), поэтому файлы больше предела
 * грузятся без хэша — дедупликации для них нет, всё остальное как обычно.
 */
export const FILE_SHA256_MAX_BYTES = 200 * 1024 * 1024;
/**
 * sha256 (hex, 64 символа) или null: файл больше `maxBytes`, нет WebCrypto
 * (страница не в защищённом контексте) или подсчёт не удался — загрузка
 * просто идёт без дедупликации.
 */
export async function fileSha256(file, opts = {}) {
    const max = opts.maxBytes ?? FILE_SHA256_MAX_BYTES;
    if (file.size > max)
        return null;
    const subtle = opts.subtle !== undefined
        ? opts.subtle
        : (globalThis.crypto?.subtle ?? null);
    if (!subtle)
        return null;
    try {
        const digest = await subtle.digest('SHA-256', await file.arrayBuffer());
        return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=file-sha256.js.map